import axios from './axios';

const trackPageView = url => axios.put('/account/pageview', {url});

export {trackPageView};
